import { Injectable } from '@angular/core';
import { HttpService } from '../../../../shared/services/http/http-client.service';


@Injectable({
  providedIn: 'root',
})
export class ListaPedidoAprovadoService {

  constructor(private http: HttpService) { }

  listApproved(params: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/listApprovedOnlineSale', params, successHandle, errorHandle);

  }

  industryOnlineSaleList(params: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/industryOnlineSaleList', params, successHandle, errorHandle);

  }

  industryOnlineSaleDetail(params: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/detailApprovedSales', params, successHandle, errorHandle);

  }

}
